export const floorTitle = (floorLevel?: number) => (floorLevel ? `Floor | ${floorLevel}` : '');
